"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _caretUp = _interopRequireDefault(require("./icons/caret-up.svg"));

var _caretDown = _interopRequireDefault(require("./icons/caret-down.svg"));

var _colors = _interopRequireDefault(require("../colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var styles = {
  root: {
    '&.ReactTable': {
      border: 'none',
      boxShadow: 'rgb(224, 224, 224) 0px 2px 4px 0px',
      '& .rt-table': {
        overflow: 'visible'
      },
      '& .rt-thead': {
        backgroundColor: _colors["default"].heather,
        boxShadow: 'none',
        fontWeight: 500,
        '& .rt-th': {
          fontSize: 10,
          overflow: 'visible',
          display: 'flex',
          alignItems: 'center',
          padding: '15px 10px',
          border: 'none',
          lineHeight: 1.5,
          textAlign: 'left',
          '&:focus': {
            outline: 'none'
          }
        }
      },
      '& .rt-thead.-header': {
        boxShadow: 'none',
        textTransform: 'uppercase'
      },
      '& .rt-thead.-filters': {
        '& .rt-tr': {
          '& .rt-th': {
            padding: 10,
            left: -5,
            marginTop: -15,
            input: {
              border: 'none',
              padding: 7,
              maxWidth: 200
            }
          }
        }
      },
      '& .-selected': {
        backgroundColor: _colors["default"].skyBlue
      },
      '& .-disabled': {
        opacity: 0.3,
        pointerEvents: 'none'
      },
      '& .rt-tr': {
        padding: '0 15px',
        '& .-sort-asc,.-sort-desc': {
          fontWeight: 700,
          boxShadow: 'none'
        },
        '& .-sort-asc': {
          '&:after': {
            marginLeft: 5,
            content: "url(".concat(_caretUp["default"], ")")
          }
        },
        '& .-sort-desc': {
          '&:after': {
            marginLeft: 5,
            content: "url(".concat(_caretDown["default"], ")")
          }
        },
        '& .rt-td': {
          fontSize: 14,
          padding: '15px 10px',
          border: 'none',
          display: 'flex',
          alignItems: 'center',
          whiteSpace: 'pre-line',
          overflow: 'visible',
          input: {
            width: '100%',
            height: '100%'
          },
          '& .tat': {
            borderRadius: 3,
            padding: 3,
            position: 'relative',
            textAlign: 'center',
            '& .flag': {
              color: 'rgb(194, 70, 85)'
            },
            '& .flag::before': {
              content: '',
              position: 'absolute',
              top: 12,
              left: -6,
              width: 0,
              height: 0,
              borderRadius: '50%',
              borderWidth: 3,
              borderStyle: 'solid',
              borderColor: 'rgb(194, 70, 85)',
              marginTop: -4
            }
          }
        }
      },
      '& .rt-tbody': {
        fontSize: '0.9rem',
        backgroundColor: _colors["default"].white,
        minHeight: 48,
        overflow: 'visible',
        '& .rt-tr': {
          '& .grid-actions': {
            margin: '-10px 0',
            display: 'none',
            a: {
              textDecoration: 'none',
              color: 'inherit'
            }
          },
          '&:hover': {
            backgroundColor: _colors["default"].smoke,
            '& .grid-actions': {
              display: 'block'
            }
          }
        },
        '& .rt-tr-group': {
          borderBottom: "1px solid ".concat(_colors["default"].gray)
        },
        '& .rt-expandable': {
          cursor: 'pointer',
          fontSize: 25,
          padding: 0,
          textAlign: 'center',
          userSelect: 'none',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }
      },
      '& .rt-tfoot': {
        boxShadow: 'none',
        borderTop: 'solid 1px rgba(0, 0, 0, 0.05)',
        '& .rt-tr': {
          '& .rt-td': {
            fontSize: '0.9rem'
          }
        }
      },
      '.rt-noData': {
        top: '50%',
        bottom: 0,
        transform: 'translate(-50%, 0)',
        fontSize: 14,
        background: 'transparent',
        padding: 15
      }
    }
  }
};
var _default = styles;
exports["default"] = _default;